module.exports = __webpack_public_path__ + "img/3.ef5f1671.jpg";